module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Black.7f0d2861.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Black.woff2
// module id = 346
// module chunks = 3